import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  Drawer,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  TextField,
  Typography,
  Tooltip,
  Collapse,
} from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'

import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useTheme } from '@mui/material'
import { templateCards, tagColumns, cardSx, cardHeaderSx, truncateText } from './constants'
import { GetRequest, PostRequest, PostRequestV2 } from '../../../common/api'
import { urls, whatsappCommunicationSentDetail } from '../../../common/constants'
import useToken from '../../../helpers/useTokens'
import { useAtomValue, useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import LineinputV2 from '../../../common/lineinputV2'
import { Item, SingleInputModal, SuccessPopUp } from '../../../common/snippets'
import AttachMenu from './AttachMenu'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import CategoryIcons from './CategoryIcons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClockRotateLeft } from '@fortawesome/free-solid-svg-icons'
import HistoryDialogs from './HistoryDialogs'
import DropDownOA from '../../../common/dropDownOA'
import { ConnectButton } from '360dialog-connect-button'
import { companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { useSearchParams } from 'react-router-dom'
import { whatsappMessageConsumption } from '../../../common/constants'
import { DEMO_COMPANY } from '../../../../helper/companyIdhardcode'

const templateModeOptions = [
  { value: 'standard', label: 'Standard' },
  { value: 'custom', label: 'Custom' },
]

const policyTemplateModeOptions = [
  { value: 1, label: 'Whatsapp 360' },
  { value: 0, label: 'Route Mobile' },
]
const isdOptionsIndia = [{ isdId: 1, isdName: '+91' }]
const isdOptionsKENYA = [{ isdId: 2, isdName: '+254' }]

const policySmsTypeMap = {
  SenderMsgBkg: 'SB',
  ReceiveMsgBkg: 'RB',
  SenderMsgDispatch: 'DS',
  ReceiverMsgDispatch: 'DR',
  SenderMsgDel: 'SD',
  ReceiveMsgDel: 'RD',
  ReceiveMsgRev: 'RR',
  IsBranchAgentEdit: 'BO',
  FOCBookingConfirmtiontoAuthority: 'FB',
  IsCargoBranchEnquiry: 'BE',
  ReceiveMsgNotification: 'RN',
  SenderMsgCancel: 'SC',
  ReceiveMsgCancel: 'RC',
  InqMsgCustomer: 'IC',
  InqMsgOperator: 'IO',
  IsReceiverDemmurage: 'DM',
  IsAdminReverseLuggage: 'AR',
  IsReceiverOtpDeliverySMS: 'OR',
  IsLRTrackingMS: 'LO',
  IsRateKgKmEdit: 'KO',
  IsCargoNotification: 'NS',
  IsCargoEventNotification: 'ES',
  IsCargoRcvrMsgdelAttach: 'RA',
  IsCargoRcvrIDMsgdel: 'RI',
  IsCargoOGCL: 'OG',
  IsCargoOutForDelMsg: 'OF',
  IsCargoAssignDeliveryAssignee: 'DA',
  ISCargoDoorDropAssign: 'DD',
}

export const WhatsappPolicy = () => {
  const [, setSearchParams] = useSearchParams()
  const [IsStandard, setIsStandard] = useState(1)
  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const companySettings = useAtomValue(companySettingsAtom)
  const { WhatsappTypeID, DefaultCurrencyID } = companySettings || {}
  const scrollRef = useRef(null)
  const containerRef = useRef(null)
  const theme = useTheme()
  const { loginData } = useToken()
  const { intCompanyID, intUserID, IsMTPLAdmin } = loginData
  const [tableData, setTableData] = useState([])
  const [tags, setTags] = useState([])
  const [attachmentOpt, setAttachmentOpt] = useState([])
  const [selectedAttachmentByCard, setSelectedAttachmentByCard] = useState({})
  const [approvalDialogOpen, setApprovalDialogOpen] = useState(false)
  const [approvalCard, setApprovalCard] = useState(null)
  const [approvalChannels, setApprovalChannels] = useState([])
  const [selectedApprovalChannel, setSelectedApprovalChannel] = useState(null)
  const [approvalCategory, setApprovalCategory] = useState('UTILITY')
  const [approvalSearch, setApprovalSearch] = useState('')
  const [channelList, setChannelList] = useState([])
  const [selectedChannel, setSelectedChannel] = useState([])
  const [selectedPartner, setSelectedPartner] = useState(null)
  const [showWhatsappDrawer, setShowWhatsappDrawer] = useState(false)
  const isdOptions = DefaultCurrencyID === 2 ? isdOptionsKENYA : isdOptionsIndia
  const defaultIsdCode = (isdOptions[0]?.isdName || '+91').replace(/\D/g, '')
  const [baalnceData,SetBalanceData]=useState({})
  const [waConfig, setWaConfig] = useState({
    isd: isdOptions[0].isdName,
    businessAccountNumber: '',
    businessBrandName: '',
    email: '',
    name: '',
    crsId: '',
  })
  const [tnc, setTnc] = useState(false)

  const [availableHeight, setAvailableHeight] = useState(null)
  const [templateIds, setTemplateIds] = useState({ standard: 0, customised: 0 })
  const [policyData, setPolicyData] = useState({})
  const [testSmsModalOpen, setTestSmsModalOpen] = useState(false)
  const [testSmsPhoneNumber, setTestSmsPhoneNumber] = useState('')
  const [selectedTestSmsCard, setSelectedTestSmsCard] = useState(null)
  const [switchConfirmCard, setSwitchConfirmCard] = useState(null)
  const [historyTemplated, setHistoryTemplated] = useState({
    Header: '',
    Category: '',
    Status: '',
    MavenMessage: '',
    StatusMessage: '',
    StatusUpdateDate: null,
    AlowAttachment: '',
    AttachmentTag: '',
    HasAttachment: '',
  })
  const [showHistoryDialog, setShowHistoryDialog] = useState(false)
  const [historyAnchorEl, setHistoryAnchorEl] = useState(null)
  const [showTags, setShowTags] = useState(false)
  const approvalCategoryOptions = [
    {
      value: 'UTILITY',
      title: 'Utility Conversations',
      description:
        'Facilitate a specific, agreed-upon request or transaction update to a customer about an ongoing transaction, including post-purchase notifications.',
    },
    {
      value: 'MARKETING',
      title: 'Marketing Conversations',
      description:
        'Include promotions, offers, informational updates, or invitations for customers to respond or take action when the conversation does not qualify as utility.',
    },
  ]
  const disableButton = () =>
    !(
      waConfig.isd &&
      waConfig.businessAccountNumber &&
      waConfig.businessBrandName &&
      waConfig.email &&
      waConfig.name &&
      waConfig.crsId &&
      tnc
    )

  const scrollCards = (direction) => {
    const el = scrollRef.current
    if (!el) return
    const step = Math.max(320, el.clientWidth * 0.8)
    el.scrollBy({ left: direction * step, behavior: 'smooth' })
  }
  const to01 = (value) => (value === 1 || value === '1' || value === true || value === 'true' ? 1 : 0)
  const handleWhatsappDrawerClose = () => setShowWhatsappDrawer(false)
  const openWhatsappMessageConsumption = () => {
    setSearchParams({ view: whatsappMessageConsumption })
  }
  const openWhatsappCommunicationSentDetail = () => {
    setSearchParams({ view: whatsappCommunicationSentDetail })
  }
  const handleCallback = (callbackObject) => {
    console.log('client ID: ' + callbackObject.client)
    console.log('channel IDs: ' + callbackObject.channels)
    if (callbackObject.revokedChannels) {
      console.log('Revoked Channel IDs: ' + callbackObject.revokedChannels)
    }
  }
  const fetchData = () => {
    GetRequest(urls.whatsappPoliciesAndTemplates, { CompanyID: intCompanyID, WhatsappTypeID })
      .then((res) => {
        if (res.status !== true) {
          throw new Error(res.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table2) || res.Data.Table2.length === 0) {
          throw new Error('Invalid response data')
        }
        if(!Array.isArray(res.Data.Table6) || res.Data.Table6.length === 0){
          throw new Error('No policy enabled')
        }
        const standardList = res.Data.Table1 || []
        const customisedList = res.Data.Table2 || []
        const activeList = res.Data.Table6
        const flags = res.Data.Table[0]
        SetBalanceData(res.Data.Table3[0])

        const customisedByKey = new Map(customisedList.map((item) => [item.SMSType, item]))
        const list = standardList.map((item) => {
          const metaData = activeList.find((a) => a.WhatsappType === item.SMSType)
          const customisedItem = customisedByKey.get(item.SMSType) || {}
          const standardMessage = item.MavenMessage || ''
          const customisedMessage = customisedItem.MavenMessage || ''
          return {
            ...item,
            ...customisedItem,
            ...metaData,
            Tags: item.Tags,
            TemplateName:item.TemplateName,
            standard: standardMessage,
            customised: customisedMessage,
            originalStandard: standardMessage,
            isActive: metaData.IsEnabled === 1,
            StandardStatus: item.Status,
            CustomStatus: customisedItem.Status || '',
            CustomStatusMessage: customisedItem.StatusMessage || '',
            CustomStatusUpdateDate: customisedItem.StatusUpdateDate || null,
            Category: customisedItem.Category || '',
            AttachmentTag: customisedItem.AttachmentTag || '',
            HasAttachment: customisedItem.HasAttachment ?? 0,
            AlowAttachment: customisedItem.AlowAttachment ?? 0,
            templateMode: customisedItem.MavenMessage ? 'custom' : 'standard',
            customTemplateName: customisedItem.TemplateName || '',
          }
        })
        const initialAttachmentSelection = {}
        list.forEach((item) => {
          if (item.AttachmentTag) {
            const selectedAttachment = (res.Data.Table4 || []).find((val) => val.AttachmentTag === item.AttachmentTag)
            if (selectedAttachment) initialAttachmentSelection[item.TemplateListID] = selectedAttachment
          }
        })
        setAttachmentOpt(res.Data.Table4)
        setSelectedAttachmentByCard(initialAttachmentSelection)
        setTableData(list)
        setTags(res.Data.Table5 || [])
        setIsStandard(to01(flags.IsStandard))
        setPolicyData(flags)
        setTemplateIds({
          standard: standardList?.TemplateID ?? 0,
          customised: customisedList?.TemplateID ?? 0,
        })
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message })
      })
      .finally(() => setLoader(false))

    GetRequest(urls.getChannels, { CompanyID: intCompanyID, WhatsappTypeID })
      .then((res) => {
        if (res.status !== true) {
          throw new Error(res.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error('Invalid response data')
        }
        const channels = res.Data.Table.map((item, index) => ({
          ...item,
          id: item.WabaAccountID || item.WAClientID || item.ChannelID || item.ID || index,
          label:
            item.MobileNumber ||
            item.PhoneNumber ||
            item.ChannelName ||
            item.DisplayName ||
            item.WabaDisplayPhoneNumber ||
            item.WabaAccountName ||
            'WhatsApp Number',
        }))
        setChannelList(channels)
        setApprovalChannels(channels)
        setSelectedChannel(channels[0])
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message })
      })
      .finally(() => setLoader(false))

    GetRequest(urls.getPartners, { CompanyID: intCompanyID })
      .then((res) => {
        if (res.status !== true) {
          throw new Error(res.ErrMessage || 'Request Failed')
        }
        const partners = res?.Data?.Table || []
        setSelectedPartner(partners[0] || null)
        setWaConfig((prev) => ({
          ...prev,
          businessBrandName: loginData?.strCompanyName || '',
          name: loginData?.strUserName || loginData?.UserName || '',
          crsId: loginData?.intCompanyID || '',
        }))
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message })
      })
      .finally(() => setLoader(false))
  }
  useEffect(() => {
    if ([0, 1].includes(WhatsappTypeID)) {
      fetchData()
    }
  }, [WhatsappTypeID])

  useLayoutEffect(() => {
    const updateHeight = () => {
      if (!containerRef.current) return
      const rect = containerRef.current.getBoundingClientRect()
      const nextHeight = Math.max(200, window.innerHeight - rect.top - 10)
      setAvailableHeight(nextHeight)
    }
    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [])

  const toggleActive = (smsType) => {
    setTableData((prev) => prev.map((item) => (item.SMSType === smsType ? { ...item, isActive: item.isActive ? 0 : 1 } : item)))
  }

  const updateTemplateBody = (templateId, value, isStandard) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.TemplateListID === templateId
          ? {
              ...item,
              standard: isStandard ? value : item.standard,
              customised: isStandard ? item.customised : value,
            }
          : item
      )
    )
  }

  const getCardTemplateMode = (card) => {
    if (IsStandard) return 'standard'
    return card?.templateMode || 'standard'
  }

  const getCardMessage = (card) => {
    if (IsStandard) return card.standard || ''
    return getCardTemplateMode(card) === 'custom' ? card.customised || '' : card.standard || ''
  }

  const getCardPrimaryStatus = (card) => {
    const mode = getCardTemplateMode(card)
    return mode === 'custom' ? card.CustomStatus || card.StandardStatus || '' : card.StandardStatus || ''
  }

  const hasStandardChanged = (card) => IsStandard && (card.standard || '') !== (card.originalStandard || '')

  const row1Cards = tableData.filter((card) => Number(card.RowNo) === 0).sort((a, b) => Number(a.ColumnNo || 0) - Number(b.ColumnNo || 0))
  const row2Cards = tableData.filter((card) => Number(card.RowNo) === 1).sort((a, b) => Number(a.ColumnNo || 0) - Number(b.ColumnNo || 0))

  const maxColumns = Math.max(0, ...tableData.map((card) => Number(card.ColumnNo) || 0))
  const buildRowCells = (cards) =>
    Array.from({ length: maxColumns + 1 }, (_, index) => cards.find((card) => Number(card.ColumnNo) === index) || null)

  const getSelectedAttachment = (card) => selectedAttachmentByCard[card.TemplateListID] || {}

  const encryptMessage = (msg) => {
    let count = 1
    let str = ''
    let tags = ''
    let append = 0
    let encryptedMessage = msg

    for (let i = 0; i < encryptedMessage.length; i++) {
      const char = encryptedMessage.charAt(i)
      if (char === '[') append = 1
      if (append) str += char
      if (char === ']') {
        tags += `${str},`
        encryptedMessage = encryptedMessage.replace(str, `{{${count}}}`)
        count++
        i = i - str.length + 4 + count.toString().length
        str = ''
        append = 0
      }
    }

    return [encryptedMessage, tags ? tags.slice(0, -1) : '']
  }

  const getPolicyToggleValue = (smsTypes, fallbackValue) => {
    const expectedTypes = Array.isArray(smsTypes) ? smsTypes : [smsTypes]
    const card = tableData.find((item) => expectedTypes.includes(item.SMSType))
    return card ? to01(card.isActive) : to01(fallbackValue)
  }

  const buildPolicyPayload = () => {
    const p = policyData || {}
    const payload = {
      WAPolicyID: p.WAPolicyID || 0,
      CompanyID: intCompanyID,
      HrsAfterReceive: p.HrsAfterReceive ?? 0,
      CargoBookingInquiryOperatorPhoneNos: p.CargoBookingInquiryOperatorPhoneNos ?? '',
      ReceiverDemmurageOnce: to01(p.ReceiverDemmurageOnce),
      AdminReverseLuggageOtpNo: p.AdminReverseLuggageOtpNo ?? '',
      ReceiverDemmuragePeriod: p.ReceiverDemmuragePeriod ?? 0,
      RecMsgDemDays: p.RecMsgDemDays ?? '',
      IsStandard: to01(IsStandard),
      WabaAccountID: selectedChannel?.WabaAccountID || selectedChannel?.WAClientID || p.WabaAccountID || '',
    }

    Object.entries(policySmsTypeMap).forEach(([payloadKey, smsType]) => {
      payload[payloadKey] = getPolicyToggleValue(smsType, p[payloadKey])
    })

    return payload
  }

  const handleSave = () => {
    const policyPayload = buildPolicyPayload()
    setLoader(true)
    PostRequest(urls.whatsappPoliciesInsertUpdate, policyPayload)
      .then((res) => {
        if (res?.status !== true && res?.status !== 'Success') {
          throw new Error(res?.ErrMessage || res?.Message || 'WhatsApp policy update failed')
        }
        setAlert({ show: true, msg: res?.Message || res?.ErrMessage || 'WhatsApp policy updated successfully', success: true })
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message })
      })
      .finally(() => setLoader(false))
  }

  const handleTemplateModeChange = (nextIsStandard) => {
    setIsStandard(to01(nextIsStandard))
  }
  const handleTestSms = (card) => {
    setSelectedTestSmsCard(card)
    setTestSmsPhoneNumber('')
    setTestSmsModalOpen(true)
  }

  const confirmTestSms = () => {
    const phoneNumber = testSmsPhoneNumber.replace(/\D/g, '')
    if (!phoneNumber) {
      setAlert({ show: true, msg: 'Please enter phone number' })
      return
    }
    if (!selectedTestSmsCard) return
    const payload = {
      CompanyID: intCompanyID,
      Tags: selectedTestSmsCard.Tags,
      Master: selectedTestSmsCard.Master || '',
      WhatsappTypeID,
      TemplateName: IsStandard ? selectedTestSmsCard.TemplateName : selectedTestSmsCard.customTemplateName || '',
      SendTo: phoneNumber,
    }
    setLoader(true)
    PostRequest(urls.sendAMessage, payload)
      .then((res) => {
        if (res?.status !== true && res?.status !== 'Success') {
          throw new Error(res?.Message || res?.ErrMessage || 'Failed to send WhatsApp test message')
        }
        setTestSmsModalOpen(false)
        setSelectedTestSmsCard(null)
        setTestSmsPhoneNumber('')
        setAlert({ show: true, msg: res?.Message || res?.ErrMessage || 'Test WhatsApp message sent successfully', success: true })
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message })
      })
      .finally(() => setLoader(false))
  }

  const switchToStandard = (card) => {
    setSwitchConfirmCard(card)
  }

  const confirmSwitchToStandard = () => {
    if (!switchConfirmCard) return
    setTableData((prev) =>
      prev.map((item) =>
        item.TemplateListID === switchConfirmCard.TemplateListID
          ? {
              ...item,
              customised: item.standard,
            }
          : item
      )
    )
    setSwitchConfirmCard(null)
  }
  const handleHistoryDialogOpen = (event, card) => {
    const cardElement = event.currentTarget.closest('[data-history-anchor="true"]')
    const params = {
      CompanyID: IsStandard ? 0 : intCompanyID,
      SmsType: card.SMSType,
      WhatsappTypeID,
    }
    GetRequest(urls.whatsappTemplateHistory, params).then(
      function (value) {
        if (value.status) {
          if (value?.Data?.Table[0]) {
            let data = value?.Data?.Table[0]
            setHistoryTemplated((prev) => ({
              ...prev,
              ...data,
              Header: card.Header,
            }))
            setHistoryAnchorEl(cardElement)
            setShowHistoryDialog(true)
          } else {
            setHistoryTemplated((prev) => ({ ...prev, Header: card.Header, MavenMessage: 'No Preview History' }))
            setHistoryAnchorEl(cardElement)
            setShowHistoryDialog(true)
          }
        } else {
          console.log('Error: ', value.Message)
        }
      },
      function (error) {
        console.log('Error: ', error)
        setAlert({ show: true, msg: error.message })
      }
    )
  }

  const handleHistoryDialogClose = () => {
    setShowHistoryDialog(false)
    setHistoryAnchorEl(null)
  }

  const handleTemplateSelectionChange = (card, value) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.TemplateListID === card.TemplateListID
          ? {
              ...item,
              templateMode: value === 'custom' ? 'custom' : 'standard',
              customised: value === 'custom' ? item.customised || '' : item.customised,
            }
          : item
      )
    )
  }

  const getTemplateModeLabel = (card) => {
    const selectedMode = IsStandard ? 'standard' : card?.templateMode || 'standard'
    return templateModeOptions.find((item) => item.value === selectedMode)?.label || ''
  }

  const openApprovalDialog = (card) => {
    setApprovalCard(card)
    setApprovalCategory(card.Category || 'UTILITY')
    setApprovalChannels(channelList)
    setSelectedApprovalChannel(channelList[0] || null)
    setApprovalDialogOpen(true)
  }

  const closeApprovalDialog = () => {
    setApprovalDialogOpen(false)
    setApprovalCard(null)
    setApprovalChannels([])
    setSelectedApprovalChannel(null)
    setApprovalSearch('')
  }

  const handleApplyTemplate = () => {
    if (!approvalCard) return
    if (!selectedApprovalChannel) {
      setAlert({ show: true, msg: 'Please choose a WhatsApp number' })
      return
    }
    if (!selectedPartner?.PartnerID) {
      setAlert({ show: true, msg: 'Unable to determine partner details for template registration' })
      return
    }

    const message = getCardMessage(approvalCard)
    if (!message) {
      setAlert({ show: true, msg: 'Please enter some text to apply for a template' })
      return
    }

    const wabaAccountID = selectedApprovalChannel.WabaAccountID || ''
    if (!wabaAccountID) {
      setAlert({ show: true, msg: 'Unable to determine WhatsApp account for template registration' })
      return
    }

    const [encryptedMessage, tags] = encryptMessage(message)
    const selectedAttachment = getSelectedAttachment(approvalCard)
    const body = {
      CompanyID: IsStandard || getCardTemplateMode(approvalCard) === 'standard' ? 0 : intCompanyID,
      SmsType: approvalCard.SMSType,
      Master: approvalCard.Master,
      WAMessage: encryptedMessage,
      Message: message,
      WabaAccountID: wabaAccountID,
      PartnerID: selectedPartner.WAPartnerID,
      Tags: tags,
      Category: approvalCategory,
      HasAttachment: Object.keys(selectedAttachment).length === 0 ? 0 : 1,
      AttachmentType: selectedAttachment?.AttachmentType || '',
      AttachmentTag: selectedAttachment?.AttachmentTag || '',
      WhatsappTypeID,
    }

    setLoader(true)
    PostRequest(urls.applyTemplateV2, body)
      .then((res) => {
        if (res?.status !== true) {
          throw new Error(res?.Message || res?.ErrMessage || 'Template apply failed')
        }
        setAlert({ show: true, msg: res?.Message || res?.ErrMessage || 'Template applied successfully', success: true })
        closeApprovalDialog()
        fetchData()
      })
      .catch((err) => setAlert({ show: true, msg: err.message }))
      .finally(() => setLoader(false))
  }

  const filteredApprovalChannels = approvalChannels.filter((channel) =>
    (channel.label || '').toLowerCase().includes(approvalSearch.trim().toLowerCase())
  )

  useEffect(() => {
    if (channelList.length > 1) {
      setSelectedChannel(IsStandard ? channelList[0] : channelList[1])
    }
  }, [IsStandard, channelList])
  return (
    <Box
      ref={containerRef}
      sx={{
        height: availableHeight ? `${availableHeight}px` : 'auto',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          flexWrap: 'wrap',
          padding: '10px 24px',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', marginRight: '8px', minWidth: '220px' }}>
          <DropDownOA
            id="whatsapp-template-mode"
            label="Template Mode"
            width="100%"
            data={policyTemplateModeOptions}
            idKey="value"
            dataKey="label"
            value={IsStandard === 1 ? 'Whatsapp 360' : 'Route Mobile'}
            defaultvalue={IsStandard === 1 ? 'Whatsapp 360' : 'Route Mobile'}
            noCross={true}
            onSelect={(val) => handleTemplateModeChange(val?.value)}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', marginRight: '8px' }}>
          <DropDownOA
            id={`whatsapp-throught`}
            label={'Whatsapp Through'}
            width={'100%'}
            data={channelList}
            idKey={'WAClientID'}
            dataKey={'ClientName'}
            value={selectedChannel?.ClientName || ''}
            defaultvalue={selectedChannel?.ClientName || ''}
            noCross={true}
            disabled={true}
          />
        </Box>
        {IsStandard ? (
          <></>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', marginRight: '8px' }}>
            <Button
              variant="outlined"
              sx={{
                borderRadius: '24px',
                px: 2,
                py: 0.75,
                fontWeight: 600,
                textTransform: 'none',
                borderColor: theme.palette.primary.main,
                color: theme.palette.primary.main,
                whiteSpace: 'nowrap',
              }}
              onClick={() => setShowWhatsappDrawer(true)}
            >
              Link Your Whatsapp Account
            </Button>
          </Box>
        )}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', marginRight: '8px' }}>
          <Button
            variant="outlined"
            sx={{ height: '36px', paddingY: '6px !important' }}
            className="btn btn-primary"
            onClick={openWhatsappMessageConsumption}
          >
            WhatsApp Message Consumption
          </Button>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', marginRight: '8px' }}>
          <Button
            variant="outlined"
            sx={{ height: '36px', paddingY: '6px !important' }}
            className="btn btn-primary"
            onClick={openWhatsappCommunicationSentDetail}
          >
            Whatsapp Communication Sent Detail Report
          </Button>
        </Box>
        <Box>
          {(baalnceData?.isPrepaid ? 'Prepaid' : 'Postpaid') +
            ` | Remaining : ${baalnceData?.isPrepaid ? baalnceData?.RemainingPrepaidBalance || 0 : baalnceData?.RemainingPostpaidCredit || 0}` +
            `${baalnceData?.ASonDate ? ` as on ${baalnceData.ASonDate}` : ''}`}
        </Box>

        <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'end', flexGrow: 1 }}>
          <Button
            variant="contained"
            onKeyDown={(e) => {}}
            id={'search_btn'}
            sx={{ width: '40px', height: '36px', paddingY: '6px !important' }}
            className="btn btn-primary"
            onClick={handleSave}
          >
            Save
          </Button>
        </Box>
      </Box>

      <Drawer anchor="right" open={showWhatsappDrawer} onClose={handleWhatsappDrawerClose}>
        <Box sx={{ width: { xs: '100vw', sm: 420 }, display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Box
            sx={{
              background: theme.palette.primary.main,
              color: '#fff',
              px: 2,
              py: 1.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>Configuration</Typography>
            <IconButton onClick={handleWhatsappDrawerClose} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5, overflowY: 'auto', flex: '1 1 auto' }}>
            <Box sx={{ display: 'grid', gridTemplateColumns: '110px 1fr', gap: 1.5 }}>
              <Box className="input--wrapper" style={{ width: '100%', marginBottom: '0px' }}>
                <DropDownOA
                  id="wa-isd"
                  label="ISD"
                  width="100%"
                  data={isdOptions}
                  idKey="isdId"
                  dataKey="isdName"
                  value={waConfig.isd}
                  defaultvalue={waConfig.isd}
                  noCross={true}
                  onSelect={(val) => setWaConfig((prev) => ({ ...prev, isd: val?.isdName || '' }))}
                />
              </Box>
              <Box className="input--wrapper" style={{ width: '100%', marginBottom: '0' }}>
                <LineinputV2
                  label="Whatsapp Business Account Number"
                  id="wa-business-account-number"
                  name="wa-business-account-number"
                  value={waConfig.businessAccountNumber}
                  onBlur={(e) => setWaConfig((prev) => ({ ...prev, businessAccountNumber: e.target.value }))}
                />
              </Box>
            </Box>
            <Box className="input--wrapper" style={{ width: '100%', marginBottom: '0' }}>
              <LineinputV2
                label="Whatsapp Business Brand Name"
                id="wa-business-brand-name"
                name="wa-business-brand-name"
                value={waConfig.businessBrandName}
                onBlur={(e) => setWaConfig((prev) => ({ ...prev, businessBrandName: e.target.value }))}
              />
            </Box>
            <Box className="input--wrapper" style={{ width: '100%', marginBottom: '0' }}>
              <LineinputV2
                label="Email Address"
                id="wa-email-address"
                name="wa-email-address"
                value={waConfig.email}
                onBlur={(e) => setWaConfig((prev) => ({ ...prev, email: e.target.value }))}
              />
            </Box>
            <Box className="input--wrapper" style={{ width: '100%', marginBottom: '0' }}>
              <LineinputV2
                label="Name"
                id="wa-name"
                name="wa-name"
                value={waConfig.name}
                onBlur={(e) => setWaConfig((prev) => ({ ...prev, name: e.target.value }))}
              />
            </Box>
            <Box className="input--wrapper" style={{ width: '100%', marginBottom: '0' }}>
              <LineinputV2 label="CRS ID" id="wa-crs-id" name="wa-crs-id" value={waConfig.crsId} disabled={true} />
            </Box>
            <FormControlLabel
              control={<Checkbox checked={tnc} onChange={(e) => setTnc(e.target.checked)} />}
              label={<Typography sx={{ fontSize: '12px' }}>You agree to Maventech Lab's Whatsapp Commercials and Policy</Typography>}
            />
            <ConnectButton
              partnerId={selectedPartner?.WAPartnerID || ''}
              callback={handleCallback}
              className={disableButton() ? 'dialog360Button disabled' : 'dialog360Button'}
              label="Connect with Maventech"
              requestedNumber={waConfig.businessAccountNumber}
              queryParameters={{
                email: waConfig.email,
                name: waConfig.name,
                partner: `${loginData?.intCompanyID || ''}`,
                redirect_url: `https://busapi.mavenconnect.tech/api/Setup?clientId=${loginData?.intCompanyID || ''}&client=&channels=`,
              }}
            />
            <Button variant="contained" disabled sx={{ width: '100%', fontSize: '16px', py: 1.1, textTransform: 'uppercase' }}>
              Add new whatsapp number
            </Button>
          </Box>
        </Box>
      </Drawer>

      <Box
        sx={{
          flex: '1 1 auto',
          minHeight: 0,
          overflowY: 'auto',
          borderBottom: '1px solid #cfd4dc',
          padding: '0 24px',
        }}
      >
        <Box sx={{ position: 'relative', overflow: 'visible', width: '100%' }}>
          <IconButton
            onClick={() => scrollCards(-1)}
            sx={{
              position: 'absolute',
              left: '-16px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 10,
              color: '#fff',
              background: theme.palette.secondary.main,
              border: `2px solid ${theme.palette.primary.main}`,
              '&:hover': { background: theme.palette.primary.main },
            }}
          >
            <ChevronLeftIcon />
          </IconButton>

          <Box
            ref={scrollRef}
            sx={{
              display: 'inline-flex',
              flexDirection: 'column',
              gap: '10px',
              overflowX: 'auto',
              overflowY: 'hidden',
              maxWidth: '100%',
              scrollBehavior: 'smooth',
              alignItems: 'stretch',
              padding: '0',
              '&::-webkit-scrollbar': { height: '8px' },
              '&::-webkit-scrollbar-thumb': { background: '#b8c2d0', borderRadius: '8px' },
            }}
          >
            {[
              { rowNo: 1, cards: buildRowCells(row1Cards) },
              { rowNo: 2, cards: buildRowCells(row2Cards) },
            ].map(({ rowNo, cards }) => (
              <Box
                key={`row-${rowNo}`}
                sx={{
                  display: 'grid',
                  gridTemplateColumns: `repeat(${maxColumns + 1}, 300px)`,
                  gap: '10px',
                  width: 'max-content',
                }}
              >
                {cards.map((card, index) => {
                  if (!card) {
                    return <Box key={`row-${rowNo}-empty-${index}`} sx={{ width: 300 }} />
                  }
                  const hasExtraInputs =
                    (Array.isArray(card.config) && card.config.length) ||
                    card.TemplateListID === 'ReceiverSMSNotification' ||
                    card.TemplateListID === 'CargoOperatorBookingInquirySMS' ||
                    card.TemplateListID === 'ReceiverSMSDemmurage'
                  const textRows = card.TemplateListID === 'ReceiverSMSDemmurage' ? 5 : hasExtraInputs ? 6 : 8
                  const effectiveMode = getCardTemplateMode(card)
                  const isApproved = effectiveMode === 'standard' ? card.StandardStatus === 'approved' : card.CustomStatus === 'approved'
                  const showTestButton = isApproved
                  const showApplyButton = hasStandardChanged(card) || !isApproved
                  return (
                    <Box
                      key={card.TemplateListID}
                      sx={{
                        ...cardSx,
                        width: 300,
                      }}
                      data-history-anchor="true"
                    >
                      <Box sx={{ ...cardHeaderSx, background: theme.palette.primary.main }}>
                        <Checkbox
                          checked={!!card.isActive}
                          onChange={() => toggleActive(card.SMSType)}
                          icon={<RadioButtonUncheckedRoundedIcon />}
                          checkedIcon={<CheckCircleRoundedIcon />}
                          disableRipple
                          sx={{
                            padding: 0,
                            color: 'rgba(255,255,255,0.7)',
                            '&.Mui-checked': { color: '#fff' },
                            '& .MuiSvgIcon-root': { fontSize: 20 },
                          }}
                        />
                        <Box sx={{ minWidth: 0, flex: '1 1 auto' }}>
                          <Tooltip
                            title={card.Header || ''}
                            placement="top"
                            arrow
                            slotProps={{
                              tooltip: { sx: { fontSize: '14px' } },
                            }}
                          >
                            <Typography sx={{ ...truncateText, fontWeight: 700, color: '#fff', fontSize: '15px' }}>
                              {card.Header}
                            </Typography>
                          </Tooltip>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0, ml: 'auto' }}>
                          <CategoryIcons Category={card.Category} />
                          {IsStandard && !IsMTPLAdmin ? null : (
                            <Tooltip title={'history'} placement="top">
                              <FontAwesomeIcon
                                icon={faClockRotateLeft}
                                size="lg"
                                fontSize={20}
                                className="HistoryIcons"
                                onClick={(e) => handleHistoryDialogOpen(e, card)}
                              />
                            </Tooltip>
                          )}
                          {card?.AlowAttachment === 1 ? (
                            <AttachMenu
                              label={
                                <AttachFileIcon
                                  sx={{
                                    margin: 0,
                                    color: '#fff',
                                    transform: 'rotate(45deg)',
                                    fontSize: 24,
                                  }}
                                />
                              }
                              options={attachmentOpt.filter((a) => a.TemplateListID === +card.TemplateListID)}
                              selectedValue={getSelectedAttachment(card)}
                              onselect={(val) => {
                                setSelectedAttachmentByCard((prev) => ({ ...prev, [card.TemplateListID]: val }))
                              }}
                              idKey="AttachmentTag"
                              dataKey="AttachmentName"
                            />
                          ) : null}
                        </Box>
                      </Box>
                      <Box sx={{ padding: 0 }}>
                        <TextField
                          value={getCardMessage(card)}
                          onChange={(e) =>
                            updateTemplateBody(card.TemplateListID, e.target.value, getCardTemplateMode(card) === 'standard')
                          }
                          multiline
                          rows={textRows}
                          disabled={
                            !(IsStandard && intCompanyID === DEMO_COMPANY) && (IsStandard || getCardTemplateMode(card) === 'standard')
                          }
                          placeholder={getCardTemplateMode(card) === 'standard' ? 'Standard template' : 'Customised template'}
                          size="small"
                          fullWidth
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              fontSize: '15px',
                              color: '#32343a',
                              lineHeight: 1.55,
                              background: '#fff',
                              padding: '8px',
                              border: 0,
                            },
                            '& .MuiOutlinedInput-notchedOutline': { border: 0 },
                          }}
                        />
                        {Array.isArray(card.config) && card.config.length ? (
                          <Box sx={{ padding: '0 10px 8px' }}>
                            {card.config.map((cfg) => (
                              <TextField
                                key={`${card.id}_${cfg.label}`}
                                label={cfg.label}
                                defaultValue={cfg.value}
                                size="small"
                                sx={{ width: '100%', background: '#fff' }}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ style: { fontSize: '14px', padding: '6px 8px' } }}
                              />
                            ))}
                          </Box>
                        ) : null}

                        {card.SMSType === 'RN' ? (
                          <Box sx={{ padding: '0 10px 8px' }}>
                            <TextField
                              label="Hrs"
                              value={policyData?.HrsAfterReceive ?? ''}
                              size="small"
                              sx={{ width: '100%', background: '#fff' }}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ style: { fontSize: '14px', padding: '6px 8px' } }}
                              onChange={(e) => setPolicyData((prev) => ({ ...prev, HrsAfterReceive: e.target.value }))}
                            />
                          </Box>
                        ) : null}

                        {card.SMSType === 'IO' ? (
                          <Box sx={{ padding: '0 10px 8px' }}>
                            <TextField
                              label="Mobile Nos"
                              value={policyData?.CargoBookingInquiryOperatorPhoneNos ?? ''}
                              size="small"
                              sx={{ width: '100%', background: '#fff' }}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ style: { fontSize: '14px', padding: '6px 8px' } }}
                              onChange={(e) => setPolicyData((prev) => ({ ...prev, CargoBookingInquiryOperatorPhoneNos: e.target.value }))}
                            />
                          </Box>
                        ) : null}
                      </Box>
                      <Box
                        sx={{
                          marginTop: 'auto',
                          borderTop: '1px solid #d6dbe3',
                          display: 'flex',
                          justifyContent: !showApplyButton ? 'space-between' : 'flex-end',
                          alignItems: 'center',
                          gap: '6px',
                          padding: '8px 10px 10px',
                        }}
                      >
                        {!showApplyButton ? (
                          <Button
                            variant="text"
                            sx={{
                              fontSize: '16px',
                              fontWeight: 700,
                              minWidth: 'auto',
                              padding: 0,
                              display: 'flex',
                              gap: '6px',
                              color: '#07a884',
                              lineHeight: 1,
                              '& .MuiButton-startIcon': { margin: 0 },
                            }}
                            onClick={() => handleTestSms(card)}
                          >
                            <WhatsAppIcon sx={{ fontSize: '20px' }} />
                            Test
                          </Button>
                        ) : null}
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            gap: '8px',
                            minWidth: 0,
                            flex: showTestButton ? 1 : '0 1 auto',
                          }}
                        >
                          {!IsStandard ? (
                            <Box
                              sx={{
                                width: '100px',
                                '& .dropdown--wrapper': { width: '100%' },
                                '& .dropdown--wrapper .inp--field': {
                                  height: '34px',
                                  borderRadius: '8px',
                                  padding: '0 0 0 12px',
                                  fontSize: '14px !important',
                                  borderColor: '#9ea3aa',
                                },
                                '& .dropdown--wrapper.active .inp--field, & .dropdown--wrapper .inp--field.active': {
                                  borderColor: '#07a884',
                                },
                                '& .dropdown--wrapper .inp--label': {
                                  top: '7px',
                                  left: '10px',
                                  fontSize: '11px',
                                },
                                '& .dropdown--wrapper .inp--label.active, & .dropdown--wrapper .inp--label.filled': {
                                  top: '-7px',
                                  left: '10px',
                                  fontSize: '11px',
                                },
                                '& .dropdown--wrapper .caret--icon': {
                                  top: '7px',
                                  right: '11px',
                                },
                                '& .dropdown--wrapper .drop--wrapper': {
                                  top: '38px',
                                },
                              }}
                            >
                              <DropDownOA
                                id={`wa-template-mode-${card.TemplateListID}`}
                                label={'Template'}
                                width={'100%'}
                                data={templateModeOptions}
                                idKey={'value'}
                                dataKey={'label'}
                                value={getTemplateModeLabel(card)}
                                defaultvalue={getTemplateModeLabel(card)}
                                noCross={true}
                                portal={true}
                                searchPlaceholder={'Search Template'}
                                onSelect={(val) => handleTemplateSelectionChange(card, val.value)}
                              />
                            </Box>
                          ) : null}
                          {showApplyButton ? (
                            <Button
                              variant="outlined"
                              sx={{
                                color: '#07a884',
                                borderColor: '#07a884',
                                fontSize: '14px',
                                fontWeight: 600,
                                minWidth: 'auto',
                                padding: '6px 14px',
                                borderRadius: '8px',
                                lineHeight: 1.2,
                              }}
                              onClick={() => openApprovalDialog(card)}
                            >
                              APPLY
                            </Button>
                          ) : (
                            <Typography
                              sx={{
                                color: '#39d353',
                                fontWeight: 600,
                                fontSize: '14px',
                                textTransform: 'capitalize',
                              }}
                            >
                              {getCardPrimaryStatus(card)}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  )
                })}
              </Box>
            ))}
          </Box>

          <IconButton
            onClick={() => scrollCards(1)}
            sx={{
              position: 'absolute',
              right: '-16px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 10,
              color: '#fff',
              background: theme.palette.secondary.main,
              border: `2px solid ${theme.palette.primary.main}`,
              '&:hover': { background: theme.palette.primary.main },
            }}
          >
            <ChevronRightIcon />
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ background: '#f4f4f5', border: '1px solid #cfd4dc', borderTop: 0 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'stretch',
            gap: 0,
            minHeight: showTags ? 0 : '64px',
          }}
        >
          <Box sx={{ height: 'auto', alignSelf: 'stretch', background: theme.palette.primary.main }}>
            <IconButton
              onClick={() => setShowTags((prev) => !prev)}
              sx={{
                width: '54px',
                minWidth: '54px',
                borderRadius: 0,
                background: theme.palette.primary.main,
                color: '#fff',
                height: '55px',
                borderRight: '1px solid rgba(255,255,255,0.25)',
              }}
            >
              {showTags ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
            </IconButton>
          </Box>
          <Box sx={{ flex: 1, overflow: 'hidden' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px 14px 8px',
                borderBottom: showTags ? '1px solid #d7dbe3' : 0,
              }}
            >
              <Typography sx={{ fontSize: '24px', fontWeight: 800, letterSpacing: '0.3px' }}>Tags:</Typography>
            </Box>

            <Box
              sx={{
                maxHeight: showTags ? 'none' : '64px',
                overflow: 'hidden',
                transition: 'max-height 220ms ease',
              }}
            >
              <Box sx={{ padding: '0 14px 14px' }}>
                <Box
                  sx={{
                    display: 'grid',
                    width: '100%',
                    gridTemplateColumns: {
                      xs: 'repeat(2, minmax(140px, 1fr))',
                      md: 'repeat(4, minmax(140px, 1fr))',
                      xl: 'repeat(6, minmax(150px, 1fr))',
                    },
                    gap: '0px 10px',
                  }}
                >
                  {tags.map(({ Tag, TagDescription }, index) => (
                    <Box key={`${index}_${Tag}`} sx={{ display: 'flex', alignItems: 'center', gap: '7px', marginBottom: '6px' }}>
                      <Box
                        sx={{
                          minWidth: '52px',
                          border: '1px solid #cfd3db',
                          borderRadius: '4px',
                          textAlign: 'center',
                          fontSize: '12px',
                          color: '#2d3d53',
                          fontWeight: 700,
                          background: '#f7f7f8',
                          padding: '2px 5px',
                        }}
                      >
                        {Tag}
                      </Box>
                      <Typography sx={{ fontSize: '13px', color: '#3c4046' }}>{TagDescription}</Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      {testSmsModalOpen ? (
        <SingleInputModal
          data={{
            headTxt: `Test Message For ${selectedTestSmsCard?.Header}`,
            inputId: 'test_sms_phone_number',
            inputLabel: 'Enter Mobile With ISD Code',
            inputName: 'test_sms_phone_number',
            inputType: 'text',
            inputValue: testSmsPhoneNumber,
            instructionText: `Example if your test mobile is +91 98765 43210 enter 919876543210`,
            mainButtonLabel: 'Send',
            mainButtonId: 'test_sms_confirm',
          }}
          functions={{
            updateModal: () => {
              setTestSmsModalOpen(false)
              setSelectedTestSmsCard(null)
            },
            onChangeInput: (val) => setTestSmsPhoneNumber(val.replace(/\D/g, '')),
            onClickButton: confirmTestSms,
            onCloseCallback: () => {
              setTestSmsModalOpen(false)
              setSelectedTestSmsCard(null)
            },
          }}
          maxLength={12}
        />
      ) : null}
      <Dialog
        open={approvalDialogOpen}
        onClose={closeApprovalDialog}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: 'min(1040px, calc(100vw - 32px))',
            maxWidth: 'none',
            borderRadius: '16px',
            overflow: 'hidden',
            maxHeight: 'calc(100vh - 72px)',
          },
        }}
      >
        <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
              minHeight: 0,
              flex: '1 1 auto',
              overflow: 'hidden',
            }}
          >
            <Box sx={{ borderRight: { md: `1px solid ${theme.palette.divider}` }, background: '#fff' }}>
              <Box
                sx={{
                  background: theme.palette.primary.main,
                  color: '#fff',
                  px: 2,
                  py: 1.25,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.25,
                }}
              >
                <Box
                  sx={{
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    border: '2px solid rgba(255,255,255,0.95)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '15px',
                    fontWeight: 500,
                    flexShrink: 0,
                  }}
                >
                  1
                </Box>
                <Typography sx={{ fontSize: { xs: '15px', md: '17px' }, fontWeight: 600, lineHeight: 1.15 }}>
                  Choose a Whatsapp number to register this template
                </Typography>
              </Box>
              <Box sx={{ p: 1.75 }}>
                <TextField
                  fullWidth
                  placeholder="Search Phone Number"
                  value={approvalSearch}
                  onChange={(e) => setApprovalSearch(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: '#8b8f97', fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    mb: 1.25,
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      fontSize: '13px',
                      minHeight: '40px',
                      '& input': { py: '9px' },
                    },
                  }}
                />
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, maxHeight: { xs: '220px', md: '255px' }, overflowY: 'auto' }}
                >
                  {filteredApprovalChannels.map((channel) => (
                    <Box
                      key={channel.id}
                      onClick={() => setSelectedApprovalChannel(channel)}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                        px: 0.5,
                        py: 0.5,
                        cursor: 'pointer',
                        borderRadius: '8px',
                        '&:hover': { background: '#f6f7f9' },
                      }}
                    >
                      <Radio
                        checked={selectedApprovalChannel?.id === channel.id}
                        sx={{
                          color: '#6f6f6f',
                          p: 0,
                          '&.Mui-checked': { color: theme.palette.primary.main },
                          '& .MuiSvgIcon-root': { fontSize: 18 },
                        }}
                      />
                      <Typography sx={{ fontSize: { xs: '13px', md: '14px' }, fontWeight: 600, color: '#26282d' }}>
                        {channel.label}
                      </Typography>
                    </Box>
                  ))}
                  {!filteredApprovalChannels.length ? (
                    <Typography sx={{ color: '#6b7280', px: 1 }}>No WhatsApp numbers found.</Typography>
                  ) : null}
                </Box>
              </Box>
            </Box>
            <Box sx={{ background: '#fff' }}>
              <Box
                sx={{
                  background: theme.palette.primary.main,
                  color: '#fff',
                  px: 2,
                  py: 1.25,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.25,
                }}
              >
                <Box
                  sx={{
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    border: '2px solid rgba(255,255,255,0.95)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '15px',
                    fontWeight: 500,
                    flexShrink: 0,
                  }}
                >
                  2
                </Box>
                <Typography sx={{ fontSize: { xs: '15px', md: '17px' }, fontWeight: 600, lineHeight: 1.15, flex: 1 }}>
                  Choose a Whatsapp template category
                </Typography>
                <IconButton onClick={closeApprovalDialog} sx={{ color: '#fff', p: 0.5 }}>
                  <CloseIcon sx={{ fontSize: 22 }} />
                </IconButton>
              </Box>
              <Box
                sx={{
                  p: 1.75,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  maxHeight: { xs: '220px', md: '255px' },
                  overflowY: 'auto',
                }}
              >
                {approvalCategoryOptions.map((option) => (
                  <Box
                    key={option.value}
                    onClick={() => setApprovalCategory(option.value)}
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 0.75,
                      cursor: 'pointer',
                    }}
                  >
                    <Radio
                      checked={approvalCategory === option.value}
                      sx={{
                        color: '#6f6f6f',
                        p: 0,
                        mt: '2px',
                        '&.Mui-checked': { color: theme.palette.primary.main },
                        '& .MuiSvgIcon-root': { fontSize: 18 },
                      }}
                    />
                    <Box>
                      <Typography sx={{ fontSize: { xs: '13px', md: '15px' }, fontWeight: 600, color: '#26282d', lineHeight: 1.2 }}>
                        {option.title}
                      </Typography>
                      <Typography sx={{ fontSize: { xs: '11px', md: '13px' }, lineHeight: 1.35, color: '#26282d', mt: 0.25 }}>
                        {option.description}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
          <Button
            fullWidth
            variant="contained"
            onClick={handleApplyTemplate}
            sx={{
              borderRadius: 0,
              background: theme.palette.primary.main,
              py: 1,
              fontSize: { xs: '13px', md: '15px' },
              fontWeight: 700,
              flex: '0 0 auto',
              '&:hover': { background: theme.palette.primary.dark },
            }}
          >
            SEND IT TO WHATSAPP FOR APPROVAL
          </Button>
        </DialogContent>
      </Dialog>

      <HistoryDialogs
        anchorEl={historyAnchorEl}
        attachmentOpt={attachmentOpt}
        historyTemplated={historyTemplated}
        open={showHistoryDialog}
        onClose={handleHistoryDialogClose}
        textBoxHeigth={`100px`}
        templateCheck={false}
        policiesAndTemplates={{}}
      />
    </Box>
  )
}
